import UserRoundLinkRebrand from '@/assets/icons/user-round-link-svg/user-round-link-rebrand.svg';
import Image, { type ImageProps } from 'next/image';

export const UserRoundLinkSvg = (props: Omit<ImageProps, 'src'>) => {
  const { alt = 'user round link', ...rest } = props;

  return <Image src={UserRoundLinkRebrand} alt={alt} {...rest} />;
};
